export const TransferSearchParticipantFormKey = {
  transferType: "transferType",
  deliveryCountry: "deliveryCountry",
  nextView: "nextView",
  productLine: "productLine",
  programTemplate: "programTemplate",
  clientFilter: "clientFilter",
  client: "client",
} as const;

export interface TransferSearchParticipantResult {
  programId: string;
  participantId: string;
  participantName?: string;
  participantFirstName: string;
  participantLastName: string;
  clientId: string;
  clientName: string;
  lobId: string;
  lobName: string;
  programTemplateName: string;
  programTemplateId: string;
  status: string;
  deliveryCountryCode: string;
  deliveryCountryName: string;
  isSelected?: boolean;
  [key: string]: any;
}
export interface CompleteTransferParticipantResult {
  participantName: string;
  participantId: string;
  sourceCountryCode: string;
  sourceCountryName: string;
  destinationCountryCode: string;
  destinationCountryName: string;
  productLineId: string;
  productLineName: string;
  sourceProgramTemplateId: string;
  sourceProgramTemplateName: string;
  compatibleProgramTemplateId: string;
  compatibleProgramTemplateName: string;
  clientId: string;
  clientName: string;
  nextViewId: string;
  nextViewName: string;
  failureReason?: string;
  [key: string]: any;
}
export interface TransferParticipantBase {
  participantName: string;
  participantId: string;
  sourceCountryCode: string;
  sourceCountryName: string;
  destinationCountryCode: string;
  destinationCountryName: string;
  productLineId: string;
  productLineName: string;
  sourceProgramTemplateId: string;
  sourceProgramTemplateName: string;
  compatibleProgramTemplateId: string;
  compatibleProgramTemplateName: string;
  clientId: string;
  clientName: string;
  nextViewId: string;
  nextViewName: string;
}

export interface ProcessedParticipant extends TransferParticipantBase {}

export interface UnprocessedParticipant extends TransferParticipantBase {
  failureReason: string;
}

export interface TransferParticipantResult {
  totalParticipants: number;
  processedParticipants: number;
  unProcessedParticipants: number;
  processed: ProcessedParticipant[];
  unProcessed: UnprocessedParticipant[];
}

export const TransferSearchParticipantResultFormKey = {
  isSelected: "isSelected",
  participantName: "participantName",
  programName: "programName",
  clientName: "clientName",
  lobName: "lobName",
  programTemplateName: "programTemplateName",
  deliveryCountryName: "deliveryCountryName",
  solutionOfferingsName: "solutionOfferingsName",
} as const;
export const CompleteTransferParticipantResultFormKey = {
  participantName: "participantName",
  productLine: "productLineName",
  sourceProgramTemplate: "sourceProgramTemplateName",
  compatibleProgramTemplate: "compatibleProgramTemplateName",
  solutionOfferingsName: "solutionOfferingsName",
  nextViewName: "nextViewName",
  clientName: "clientName",
  sourceCountryName: "sourceCountryName",
  destinationCountryName: "destinationCountryName",
  notes: "notes",
} as const;

export const transferTypeKey = {
  changeCountry: "changeCountry",
  changeProgram: "changeProgram",
};

export const transferSteps = {
  chooseParticipants: 0,
  transferDetails: 1,
  success: 2,
};

export const TransferProgramFormKey = {
  compatibleProgramTemplate: "compatibleProgramTemplate",
  destinationCountry: "destinationCountry",
  deliveryOffice: "deliveryOffice",
  nextLanguage: "nextLanguage",
} as const;

export interface SaveBulkTransferPayload {
  programTemplateId: string;
  countryCode: string;
  deliveryOfficeId: string;
  languageCode: string;
}

export interface SolutionOfferingsResponseType {
  id: string;
  name: string;
  nameKey: string;
}

export const CreateBulkTransferFormKey = {
  bulkProcessName: "bulkProcessName",
};

